import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHowToReg = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.222 15.889L16.444 18.667L14.778 17M12.4692 3.02278C13.8329 4.38649 13.8329 6.5975 12.4692 7.96121C11.1055 9.32492 8.89448 9.32492 7.53077 7.96121C6.16706 6.5975 6.16706 4.38649 7.53077 3.02278C8.89448 1.65907 11.1055 1.65907 12.4692 3.02278ZM14.363 12.796C13.064 12.277 11.54 11.991 10 11.991C5.952 11.991 2 13.958 2 16.983V17.983C2 18.535 2.448 18.983 3 18.983H12.413C11.8507 17.686 11.4534 14.6328 14.363 12.796ZM17 22C14.239 22 12 19.762 12 17C12 14.296 14.3 11.997 17.004 12C19.764 12.002 22 14.24 22 17C22 19.761 19.762 22 17 22Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgHowToReg);
export default ForwardRef;
